function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 0.082,
  width: 40,
  height: 40,
  rx: 20,
  fill: "#1F252E"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.982 20.082l-6.616-6.616 1.768-1.768 8.384 8.384-8.384 8.384-1.768-1.768 6.616-6.616z",
  fill: "#A7AEB7"
});

var SvgSliderLeft = function SvgSliderLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MCA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC4wODIwMzEyIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgZmlsbD0iIzFGMjUyRSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjk4MjMgMjAuMDgyMUwxNS4zNjYyIDEzLjQ2NkwxNy4xMzQgMTEuNjk4MkwyNS41MTc5IDIwLjA4MjFMMTcuMTM0IDI4LjQ2NkwxNS4zNjYyIDI2LjY5ODJMMjEuOTgyMyAyMC4wODIxWiIgZmlsbD0iI0E3QUVCNyIvPgo8L3N2Zz4K";
export { SvgSliderLeft as ReactComponent };